<nav class="navbar navbar-expand-lg menu">
    <div class="container-fluid">
      <a class="navbar-brand" href="#"><img src="{{glob.host}}filer/logo_xs"></a>
      
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <i class="bi bi-list"></i>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent" style="z-index:10">
  
        <!-- level 1 ------------>
        <app-menu></app-menu>
  
        <form class="d-flex">
          <!-- <input class="form-control me-2 search" type="search" placeholder="جستجو" aria-label="Search"> -->
          <span class="user_profile">{{glob.profile.name + ' ' + glob.profile.family}}</span>
          <!----- theme -------------->
          <span class="nav-link0 dropdown-toggle icon" href="#" id="navbar_dropdown_theme" title="پوسته نرم افزاری" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            <span class="icon-btn"><i class="bi bi-palette-fill"></i></span>
          </span>
          <ul class="dropdown-menu" aria-labelledby="navbar_dropdown_theme" style="right: initial !important;">
            <li><a class="dropdown-item disabled">داشبورد</a></li>
            <li>
              <hr class="dropdown-divider">
            </li>
            <li><a class="dropdown-item" (click)="initial_theme('base')"  [ngClass]="{'selected':glob.config.theme=='base'}">پوسته روشن</a></li>
            <li><a class="dropdown-item" (click)="initial_theme('darko')" [ngClass]="{'selected':glob.config.theme=='darko'}">پوسته تیره</a></li>
          </ul>
  
          <!----- notification --------->
          <span class="nav-link0 dropdown-toggle icon" href="#" id="navbar_dropdown_notification" title="هشدار و اعلان ها" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            <span class="icon-btn"><i class="bi bi-bell-fill"></i></span>
          </span>
          <ul class="dropdown-menu" aria-labelledby="navbar_dropdown_notification" style="right: initial !important;">
            <li><a class="dropdown-item disabled" >داشبورد</a></li>
            <li>
              <hr class="dropdown-divider">
            </li>
            <li><a class="dropdown-item" href="#"><i class="bi bi-person-bounding-box"></i> اعلان 1</a></li>
          </ul>
  
          <!----- account ------------>
          <span class="nav-link0 dropdown-toggle icon" href="#" id="navbar_dropdown_account" title="حساب کاربری" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            <span class="icon-btn"><i class="bi bi-person-fill"></i></span>
          </span>
          <ul class="dropdown-menu" aria-labelledby="navbar_dropdown_account" style="right: initial !important;">
            <li><a class="dropdown-item disabled">داشبورد</a></li>
            <li>
              <hr class="dropdown-divider">
            </li>
            <li><a class="dropdown-item disabled">{{glob.profile.name + ' ' + glob.profile.family + ' [' + glob.profile.user_name + ']'}}</a></li>
            <li>
              <hr class="dropdown-divider">
            </li>
            <li><a class="im" (click)="emode_changer(); $event.stopPropagation()" *ngIf="devmode()" title="حالت ویرایش"[ngStyle]="{color:glob.emode?'white':'#ddd'}"><i class="bi bi-pencil-fill"></i></a></li>
            <li><a class="dropdown-item text-danger" (click)="logout()"><i class="bi bi-x-circle"></i> خروج</a></li>
          </ul>
  
          <!----- exit --------------->
          <span class="icon-btn icon exit" title="خروج" (click)="logout()"><i class="bi bi-x-lg"></i></span>
        </form>
      </div>
    </div>
  </nav>